import React from 'react'
import { Box, Typography, Link } from '@mui/material'

interface Destination {
    name: string
    href: string
}

interface TopDestinationsProps {
    title: string
    destinations: Destination[]
}

export const TopDestinations: React.FC<TopDestinationsProps> = ({ title, destinations }) => {
    return (
        <Box sx={{ px: 3, py: 2 }}>
            <Typography
                variant="subtitle1"
                sx={{
                    fontWeight: 700,
                    mb: 2,
                    fontSize: '14px',
                    color: 'text.primary'
                }}
            >
                {title}
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1.5
                }}
            >
                {destinations.map((destination, index) => (
                    <Link
                        key={index}
                        href={destination.href}
                        target="_parent"
                        sx={{
                            color: 'text.secondary',
                            textDecoration: 'none',
                            fontSize: '12px',
                            '&:hover': {
                                color: 'primary.main',
                                textDecoration: 'underline'
                            }
                        }}
                    >
                        {destination.name}
                    </Link>
                ))}
            </Box>
        </Box>
    )
}

export type { TopDestinationsProps }
